/* ============================================================
   POKÉDECK THEME — theme.js
   ============================================================ */

(function() {
  'use strict';

  /* ── Sticky Header ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Search Toggle ── */
  const searchToggle = document.getElementById('search-toggle');
  const searchBar    = document.getElementById('search-bar');
  const searchClose  = document.getElementById('search-close');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      searchBar.classList.toggle('is-open');
      if (searchBar.classList.contains('is-open')) {
        searchBar.querySelector('input')?.focus();
      }
    });
    searchClose?.addEventListener('click', () => searchBar.classList.remove('is-open'));
  }

  /* ── Mobile Nav ── */
  const mobileToggle  = document.getElementById('mobile-menu-toggle');
  const mobileNav     = document.getElementById('mobile-nav');
  const mobileClose   = document.getElementById('mobile-nav-close');
  const mobileOverlay = document.getElementById('mobile-overlay');

  function openMobileNav() {
    mobileNav?.classList.add('is-open');
    mobileOverlay?.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  mobileToggle?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  mobileOverlay?.addEventListener('click', closeMobileNav);

  /* ── Product Page: Image Gallery ── */
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const featuredImg = document.getElementById('featured-product-img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (featuredImg) {
        featuredImg.style.opacity = '0';
        setTimeout(() => {
          featuredImg.src = thumb.dataset.imageSrc;
          featuredImg.alt = thumb.dataset.imageAlt;
          featuredImg.style.opacity = '1';
        }, 150);
        featuredImg.style.transition = 'opacity 0.15s';
      }
    });
  });

  /* ── Product Page: Variant Selector ── */
  const variantBtns    = document.querySelectorAll('.variant-btn');
  const variantIdInput = document.getElementById('variant-id');
  const priceEl        = document.getElementById('product-price');
  const atcBtn         = document.getElementById('add-to-cart-btn');

  if (variantBtns.length && window.__productVariants) {
    const selectedOptions = {};
    variantBtns.forEach(btn => {
      const idx = parseInt(btn.dataset.optionIndex);
      if (btn.classList.contains('is-active')) {
        selectedOptions[idx] = btn.dataset.value;
      }
    });

    variantBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIndex);
        variantBtns.forEach(b => {
          if (parseInt(b.dataset.optionIndex) === idx) {
            b.classList.remove('is-active');
          }
        });
        btn.classList.add('is-active');
        selectedOptions[idx] = btn.dataset.value;
        updateVariant();
      });
    });

    function updateVariant() {
      const match = window.__productVariants.find(v =>
        v.options.every((opt, i) => selectedOptions[i] === opt)
      );
      if (match) {
        if (variantIdInput) variantIdInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Quantity Controls ── */
  function setupQtyButtons(minusId, plusId, inputId) {
    const minus = document.getElementById(minusId);
    const plus  = document.getElementById(plusId);
    const input = document.getElementById(inputId);
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
   plus.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      const max = parseInt(input.getAttribute('max')) || 999;
      if (val < max) input.value = val + 1;
    });
  }
  setupQtyButtons('qty-minus', 'qty-plus', 'qty-input');

  /* ── AJAX Add to Cart ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('[type="submit"]');
      const variantId = document.getElementById('variant-id')?.value;
      const qty = document.getElementById('qty-input')?.value || 1;

      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await updateCartCount();
        btn.textContent = '✓ Added!';

        // Show cart drawer
        var productSection = document.querySelector('.product-page.section');
        var isBundle = productSection && productSection.dataset.isBundle === 'true';
        var productTitle = document.querySelector('.product-page__title')?.textContent || '';
        var productPrice = document.getElementById('product-price')?.textContent || '';
        var productImage = document.querySelector('#featured-product-img')?.src || '';
        openCartDrawer(productTitle, productPrice, productImage, isBundle);
        if (!isBundle) setTimeout(() => updateDrawerProgress(), 300);

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        }, 1800);
      } catch (err) {
        btn.textContent = 'Error – Try Again';
        btn.disabled = false;
        console.error(err);
      }
    });
  }

  /* ── Cart Count Update ── */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    } catch (err) { /* silent */ }
  }

  /* ── Cart Drawer ── */
  function createCartDrawer() {
    if (document.getElementById('cart-drawer')) return;
    const drawer = document.createElement('div');
    drawer.id = 'cart-drawer';
    drawer.innerHTML = `
      <div class="cart-drawer__overlay" id="cart-drawer-overlay"></div>
      <div class="cart-drawer__panel">
        <div class="cart-drawer__header">
          <span class="cart-drawer__added">✓ Added to Cart</span>
          <button class="cart-drawer__close" id="cart-drawer-close">✕</button>
        </div>
        <div class="cart-drawer__item" id="cart-drawer-item">
          <div class="cart-drawer__img-wrap" id="cart-drawer-img-wrap"></div>
          <div class="cart-drawer__info">
            <p class="cart-drawer__title" id="cart-drawer-title"></p>
            <p class="cart-drawer__price" id="cart-drawer-price"></p>
          </div>
        </div>
        <div class="cart-drawer__progress" id="drawer-progress">
          <p class="drawer-progress__heading">🏷️ Buy More, Save More</p>
          <div class="drawer-progress__tier-boxes">
            <div class="drawer-tier-box drawer-tier-box--1" id="drawer-box-1">
              <span class="drawer-tier-box__badge">10% OFF</span>
              <span class="drawer-tier-box__label">Buy 5+ Cards</span>
            </div>
            <div class="drawer-tier-box drawer-tier-box--2" id="drawer-box-2">
              <span class="drawer-tier-box__badge">15% OFF</span>
              <span class="drawer-tier-box__label">Buy 10+ Cards</span>
            </div>
            <div class="drawer-tier-box drawer-tier-box--3" id="drawer-box-3">
              <span class="drawer-tier-box__badge">20% OFF</span>
              <span class="drawer-tier-box__label">Buy 20+ Cards</span>
            </div>
          </div>
          <div class="drawer-progress__track">
            <div class="drawer-progress__fill" id="drawer-fill"></div>
          </div>
          <p class="drawer-progress__message" id="drawer-message"></p>
        </div>
        <div class="cart-drawer__actions">
          <button class="btn btn--outline btn--full" id="cart-drawer-continue">Continue Shopping</button>
          <a href="/cart" class="btn btn--primary btn--full">View Cart</a>
        </div>
      </div>
    `;
    document.body.appendChild(drawer);

    document.getElementById('cart-drawer-close').addEventListener('click', closeCartDrawer);
    document.getElementById('cart-drawer-overlay').addEventListener('click', closeCartDrawer);
    document.getElementById('cart-drawer-continue').addEventListener('click', closeCartDrawer);
  }

  function updateDrawerProgress() {
    fetch('/cart.js?t=' + Date.now())
      .then(r => r.json())
      .then(cart => {
        var count = cart.items.reduce(function(sum, item) {
         var handle = (item.handle || '').toLowerCase();
        var type = (item.product_type || '').toLowerCase();
        if (handle.indexOf('lot') !== -1 || handle.indexOf('bundle') !== -1 || handle.indexOf('gift-box') !== -1 || handle.indexOf('collection-box') !== -1) return sum;
          return sum + item.quantity;
        }, 0);
        var fill  = document.getElementById('drawer-fill');
        var msg   = document.getElementById('drawer-message');
        var box1  = document.getElementById('drawer-box-1');
        var box2  = document.getElementById('drawer-box-2');
        var box3  = document.getElementById('drawer-box-3');
        var pct   = 0;
        var color = '';
        var text  = '';

        [box1, box2, box3].forEach(b => { if (b) b.classList.remove('is-active'); });

        if (count >= 20) {
          pct   = 100;
          color = '#e85040';
          text  = '🎉 20% off applied at checkout!';
          [box1, box2, box3].forEach(b => { if (b) b.classList.add('is-active'); });
        } else if (count >= 10) {
          pct   = 50 + ((count - 10) / 10) * 50;
          color = '#e87830';
          var r2 = 20 - count;
          text  = '🔥 15% off unlocked! Add ' + r2 + ' more ' + (r2 === 1 ? 'card' : 'cards') + ' for 20% off your total purchase!';
          if (box1) box1.classList.add('is-active');
          if (box2) box2.classList.add('is-active');
        } else if (count >= 5) {
          pct   = 25 + ((count - 5) / 5) * 25;
          color = '#e8c840';
          var r1 = 10 - count;
          text  = '⚡ 10% off unlocked! Add ' + r1 + ' more ' + (r1 === 1 ? 'card' : 'cards') + ' for 15% off.';
          if (box1) box1.classList.add('is-active');
        } else {
          pct   = (count / 5) * 25;
          color = '#e8c840';
          var r0 = 5 - count;
          text  = '🃏 Add ' + r0 + ' more ' + (r0 === 1 ? 'card' : 'cards') + ' for 10% off!';
        }

        if (fill) {
          fill.style.width = Math.min(pct, 100) + '%';
          fill.style.background = 'linear-gradient(to right, #e8c840, ' + color + ')';
        }
        if (msg) msg.textContent = text;
      });
  }

  function openCartDrawer(title, price, imageUrl, isBundle) {
    createCartDrawer();
    const drawer = document.getElementById('cart-drawer');

    document.getElementById('cart-drawer-title').textContent = title;
    document.getElementById('cart-drawer-price').textContent = price;

    const imgWrap = document.getElementById('cart-drawer-img-wrap');
    if (imageUrl) {
      imgWrap.innerHTML = `<img src="${imageUrl}" alt="${title}" class="cart-drawer__img">`;
    } else {
      imgWrap.innerHTML = `<div class="cart-drawer__img-placeholder">🃏</div>`;
    }

   drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Only show progress bar for non-bundle products
    var progressEl = document.getElementById('drawer-progress');
    if (progressEl) {
      progressEl.style.display = isBundle ? 'none' : 'block';
    }

    if (!isBundle) {
      updateDrawerProgress();
    }
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* ── Cart Page: Qty + Remove ── */
  async function updateCartItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    location.reload();
  }

  document.querySelectorAll('.cart-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      const newQty = Math.max(0, (parseInt(input?.value) || 1) - 1);
      updateCartItem(key, newQty);
    });
  });
  document.querySelectorAll('.cart-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      const newQty = (parseInt(input?.value) || 1) + 1;
      updateCartItem(key, newQty);
    });
  });
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
  });

  /* ── List View: Quick Add to Cart ── */
  document.querySelectorAll('.list-atc-btn[data-variant-id]').forEach(btn => {
    if (btn.querySelector('a')) return;
    btn.addEventListener('click', async () => {
      const variantId    = btn.dataset.variantId;
      const productTitle = btn.dataset.productTitle || '';
      const productImage = btn.dataset.productImage || '';
      const productPrice = btn.dataset.productPrice || '';

      // Read quantity from the qty input in same row
      const qtyInput = btn.closest('.list-view__col-action')?.querySelector('.list-qty-input')
                    || btn.closest('.list-view__qty-action-row')?.querySelector('.list-qty-input')
                    || btn.parentElement?.querySelector('.list-qty-input');
      const quantity = parseInt(qtyInput?.value) || 1;

      btn.style.minWidth = btn.offsetWidth + 'px';
      if (navigator.vibrate) navigator.vibrate(60);

     // Show drawer immediately
     // Check current cart quantity before adding
const cartRes = await fetch('/cart.js');
const cart = await cartRes.json();
const cartItem = cart.items.find(i => String(i.variant_id) === String(variantId));
const alreadyInCart = cartItem ? cartItem.quantity : 0;
const maxQty = parseInt(qtyInput?.dataset.max) || 999;
const available = maxQty - alreadyInCart;

if (available <= 0) {
  btn.textContent = 'Max Reached';
  btn.style.background = 'var(--danger)';
  btn.style.borderColor = 'var(--danger)';
  setTimeout(() => {
    btn.textContent = 'Add to Cart';
    btn.style.background = '';
    btn.style.borderColor = '';
  }, 1600);
  return;
}

const safeQty = Math.min(quantity, available);

btn.textContent = '✓ Added!';
btn.style.background = 'orange';
btn.style.borderColor = 'orange';
var isBundle = (productTitle || '').toLowerCase().indexOf('lot') !== -1 || (productTitle || '').toLowerCase().indexOf('bundle') !== -1 || (productTitle || '').toLowerCase().indexOf('gift') !== -1;
openCartDrawer(productTitle, productPrice, productImage, isBundle);

try {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: safeQty })
  });
        await updateCartCount();
        // Small delay to ensure cart is fully updated before reading
        setTimeout(() => updateDrawerProgress(), 300);
      } catch {
        btn.textContent = 'Error';
        btn.style.background = 'var(--danger)';
        btn.style.borderColor = 'var(--danger)';
        closeCartDrawer();
      }

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.minWidth = '';
        if (qtyInput) qtyInput.value = 1;
      }, 1600);
    });
  });

  /* ── List View Qty Buttons ── */
 document.querySelectorAll('.list-view__qty').forEach(wrap => {
    wrap.querySelector('.list-qty-minus')?.addEventListener('click', () => {
      const input = wrap.querySelector('.list-qty-input');
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    wrap.querySelector('.list-qty-plus')?.addEventListener('click', () => {
      const input = wrap.querySelector('.list-qty-input');
      const max = parseInt(input.dataset.max) || 999;
      const val = parseInt(input.value) || 1;
      if (val < max) input.value = val + 1;
    });
  });

  /* ── Quick Add ── */
  document.querySelectorAll('.quick-add-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      btn.textContent = '…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        await updateCartCount();
        btn.textContent = '✓ Added';
        setTimeout(() => { btn.textContent = 'Add to Cart'; }, 1600);
      } catch {
        btn.textContent = 'Error';
      }
    });
  });

  /* ── Product Recommendations ── */
  const recsSection = document.getElementById('product-recommendations');
  if (recsSection) {
    const productId = recsSection.dataset.productId;
    const sectionId = recsSection.dataset.sectionId;
    fetch(`/recommendations/products?product_id=${productId}&limit=4&section_id=${sectionId}`)
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc    = parser.parseFromString(html, 'text/html');
        const grid   = doc.querySelector('.products-grid');
        const target = document.getElementById('recs-grid');
        if (grid && target) target.innerHTML = grid.innerHTML;
      })
      .catch(() => {
        if (recsSection) recsSection.style.display = 'none';
      });
  }
/* ── Infinite Scroll ── */
  const trigger = document.getElementById('infinite-scroll-trigger');
  const loader  = document.getElementById('infinite-scroll-loader');

  if (trigger) {
    let loading = false;
    let nextUrl = trigger.dataset.nextPage;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(async entry => {
        if (!entry.isIntersecting || loading || !nextUrl) return;
        loading = true;
        if (loader) loader.style.display = 'block';

        try {
          const res  = await fetch(nextUrl);
          const html = await res.text();
          const doc  = new DOMParser().parseFromString(html, 'text/html');

         // Handle both list view and grid view
const newRows = doc.querySelectorAll('.list-view__row');
const newCards = doc.querySelectorAll('.product-card');
const listView = document.querySelector('.list-view');
const productGrid = document.querySelector('.products-grid--collection');

if (listView && newRows.length) {
  newRows.forEach(row => {
    listView.insertBefore(row, trigger);
  });
} else if (productGrid && newCards.length) {
  newCards.forEach(card => {
    productGrid.insertBefore(card, trigger);
  });

  // Re-wire ATC buttons on new cards
  productGrid.querySelectorAll('.list-atc-btn[data-variant-id]').forEach(btn => {
    if (btn._bound) return;
    btn._bound = true;
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      const productTitle = btn.dataset.productTitle || '';
      const productImage = btn.dataset.productImage || '';
      const productPrice = btn.dataset.productPrice || '';
      const qtyInput = btn.parentElement?.querySelector('.list-qty-input');
      const quantity = parseInt(qtyInput?.value) || 1;

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const cartItem = cart.items.find(i => String(i.variant_id) === String(variantId));
      const alreadyInCart = cartItem ? cartItem.quantity : 0;
      const maxQty = parseInt(qtyInput?.dataset.max) || 999;
      const available = maxQty - alreadyInCart;

      if (available <= 0) {
        btn.textContent = 'Max Reached';
        btn.style.background = 'var(--danger)';
        btn.style.borderColor = 'var(--danger)';
        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.style.borderColor = '';
        }, 1600);
        return;
      }

      const safeQty = Math.min(quantity, available);
      btn.style.minWidth = btn.offsetWidth + 'px';
      if (navigator.vibrate) navigator.vibrate(60);

      var isBundle = (productTitle || '').toLowerCase().indexOf('lot') !== -1 || (productTitle || '').toLowerCase().indexOf('bundle') !== -1 || (productTitle || '').toLowerCase().indexOf('gift') !== -1;

      btn.textContent = '✓ Added!';
      btn.style.background = 'orange';
      btn.style.borderColor = 'orange';
      openCartDrawer(productTitle, productPrice, productImage, isBundle);

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: safeQty })
        });
        await updateCartCount();
        setTimeout(() => updateDrawerProgress(), 300);
      } catch {
        btn.textContent = 'Error';
        btn.style.background = 'var(--danger)';
        btn.style.borderColor = 'var(--danger)';
        closeCartDrawer();
      }

      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.minWidth = '';
        if (qtyInput) qtyInput.value = 1;
      }, 1600);
    });
  });

  // Re-wire qty buttons on new cards
  productGrid.querySelectorAll('.list-view__qty').forEach(wrap => {
    if (wrap._bound) return;
    wrap._bound = true;
    wrap.querySelector('.list-qty-minus')?.addEventListener('click', () => {
      const input = wrap.querySelector('.list-qty-input');
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    wrap.querySelector('.list-qty-plus')?.addEventListener('click', () => {
      const input = wrap.querySelector('.list-qty-input');
      const max = parseInt(input.dataset.max) || 999;
      const val = parseInt(input.value) || 1;
      if (val < max) input.value = val + 1;
    });
  });
}

          // Re-wire qty buttons on new rows
          document.querySelectorAll('.list-view__qty').forEach(wrap => {
            wrap.querySelector('.list-qty-minus')?.addEventListener('click', () => {
              const input = wrap.querySelector('.list-qty-input');
              const val = parseInt(input.value) || 1;
              if (val > 1) input.value = val - 1;
            });
            wrap.querySelector('.list-qty-plus')?.addEventListener('click', () => {
              const input = wrap.querySelector('.list-qty-input');
              input.value = (parseInt(input.value) || 1) + 1;
            });
          });

          // Re-wire new ATC buttons
          doc.querySelectorAll('.list-atc-btn[data-variant-id]').forEach(btn => {
            if (btn.querySelector('a')) return;
            listView.querySelectorAll('.list-atc-btn[data-variant-id]').forEach(newBtn => {
              if (newBtn._bound) return;
              newBtn._bound = true;
              newBtn.addEventListener('click', async () => {
                const variantId    = newBtn.dataset.variantId;
                const productTitle = newBtn.dataset.productTitle || '';
                const productImage = newBtn.dataset.productImage || '';
                const productPrice = newBtn.dataset.productPrice || '';
                const qtyInput = newBtn.closest('.list-view__col-action')?.querySelector('.list-qty-input')
                              || newBtn.closest('.list-view__qty-action-row')?.querySelector('.list-qty-input');
                const maxQty = parseInt(qtyInput?.dataset.max) || 999;
      const quantity = Math.min(parseInt(qtyInput?.value) || 1, maxQty);

                newBtn.style.minWidth = newBtn.offsetWidth + 'px';
                if (navigator.vibrate) navigator.vibrate(60);
                newBtn.textContent = '✓ Added!';
                newBtn.style.background = 'orange';
                newBtn.style.borderColor = 'orange';
                openCartDrawer(productTitle, productPrice, productImage, false);

                try {
                  await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: quantity })
                  });
                  await updateCartCount();
                  setTimeout(() => updateDrawerProgress(), 300);
                } catch {
                  newBtn.textContent = 'Error';
                  newBtn.style.background = 'var(--danger)';
                  newBtn.style.borderColor = 'var(--danger)';
                  closeCartDrawer();
                }

                setTimeout(() => {
                  newBtn.textContent = 'Add to Cart';
                  newBtn.style.background = '';
                  newBtn.style.borderColor = '';
                  newBtn.style.minWidth = '';
                  if (qtyInput) qtyInput.value = 1;
                }, 1600);
              });
            });
          });

          // Get next page URL
          const newTrigger = doc.getElementById('infinite-scroll-trigger');
          nextUrl = newTrigger?.dataset.nextPage || null;

        } catch (err) {
          console.error('Infinite scroll error:', err);
        }

        if (loader) loader.style.display = 'none';
        loading = false;
      });
    }, { rootMargin: '200px' });

    observer.observe(trigger);
  }
})();
